import { Component, EventEmitter, Input, Output } from '@angular/core';
import { baseCssConfigStyle } from '@finxone-platform/shared/sys-config-types';

@Component({
  standalone: false,
  selector: 'finxone-web-frontend-payment-cancellation',
  templateUrl: './payment-cancellation.component.html',
})
export class PaymentCancellationComponent {
  @Input() public contentStyle: baseCssConfigStyle;
  @Input() public isUsingHtmlStructure: boolean;
  @Input() public colorTextAlignStyle: baseCssConfigStyle;
  @Input() public renderedContent = '';
  @Input() public selectedTextStyleClass = '';
  @Input() public remainingSeconds = '';

  @Output() actionClick = new EventEmitter<void>();

  public get renderedContentWithTimer(): string {
    return `${this.renderedContent} (${this.remainingSeconds})`;
  }

  public onActionClick(): void {
    this.actionClick.emit();
  }
}
